import { InsuranceUtil, isCardProcessed } from '@monument/core';
import { useInsurance } from './useInsurance';

const { getMostRecentInsurance } = InsuranceUtil;

export const useCanCreateNewInsurance = () => {
  const { submission, cards } = useInsurance();
  const flow = submission.flow.data;
  const card = flow?.card || getMostRecentInsurance(cards.data);
  const cardStatus = card?.status;

  return !flow || isCardProcessed(cardStatus);
};
